<div style="margin-right: 32px;">
    <div>
        <h4 class="title" style="margin-top: 15px;">Excel Detail</h4>
    </div>
</div>

<div class="card" style="padding: 10px; border-radius:10px;">
    <div class="d-flex justify-content-around" style="font-size: 20px;">
        <div>
            <p><b>BANK NAME: </b> <span style="font-size: 16px; color:#2196f3;"> {{bankName}}</span></p>
        </div>
        <div>
            <p><b>PORTFOLIO: </b> <span style="font-size: 16px; color:#2196f3;"> {{portfolio}}</span></p>
        </div>
        <div>
            <p><b>PRODUCT: </b> <span style="font-size: 16px; color:#2196f3;"> {{product}} </span></p>
        </div>
        <div>
          <p><b>Bucket_numer: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_details}} </span></p>
      </div>
    </div>
</div>

<div class="card-box" style="margin: 2px;padding-bottom: 15px;">

    <div class="row">
        <div class="col-md-12">
            <div>
            <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Accounts Details</h4>
            <div style="text-align: right;">
                <button class="btn btn-primary" *ngIf="loading" (click)="Proceed()">Proceed</button>
                <!-- <button class="btn btn-primary" style="margin-top: -25px;">Manual Allocate</button> -->
            </div>
            <h4 class="title-f">Uploaded List</h4>
           <!-- <button (click)="datacheck()"  >Refresh</button> -->
           <div class="animate" *ngIf="!loading">
           </div>
           <p>Duplicate Data Table</p>
           <div class="card-box" *ngIf="loading" >
             <ag-grid-angular #agGrid
                 style="width: auto; height: 600px;"
                 class="ag-theme-alpine"
                 [rowData]="duplicate_data"
                 [rowSelection]="'multiple'"
                 [columnDefs]="columnDefs"
                 [pagination]="true">
             </ag-grid-angular>
         </div>


           <p>With OUt Duplicate Data Table</p>
            <div class="card-box" *ngIf="loading" >
                <ag-grid-angular #agGrid
                    style="width: auto; height: 600px;"
                    class="ag-theme-alpine"
                    [rowData]="Finals_excel"
                    [rowSelection]="'multiple'"
                    [columnDefs]="columnDefs"
                    [pagination]="true">
                </ag-grid-angular>
            </div>
            </div>
        </div>
    </div>


    <p-dialog header="Account Detail" [(visible)]="displayPosition" position="center" [modal]="true"
    [style]="{width: '500px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="row" style="margin-left: 0px;margin-right: 0px;">
        <div class="col-md-12">
            <div class="row" style="padding: 0px 0px 6px 10px;">
                <div class="col-md-12 detail-t">
                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">Total duplicate accounts</th>
                            <td style="padding: 10px;">{{duplication_count}}</td>
                        </tr>
                        
                    </table>
                </div>

            </div>
        </div>
        <div class="col-md-12 text-center">
            <button class="btn btn-primary" (click)="showPositionDialog_hide()">Ok</button>
        </div>
    </div>
</p-dialog>



</div>
